<p-button icon="pi pi-question-circle" [rounded]="true" severity="secondary" text="true" [outlined]="true"
    [disabled]="!active()"
    (click)="showHelp()"
    [pTooltip]="active() ? 'Help' : 'Help not available'" tooltipPosition="left"/>
